import { FaArrowRight } from "react-icons/fa6";

const Starter = ({ header, btnText }) => {
  return (
    <div className="sm:flex justify-between gap-3 grid sm:p-16  p-2">
      <h1 className="text-3xl sm:text-4xl text-[#023a51] font-semibold">
        {header}
      </h1>
      <div>
        <div className=" flex justify-between w-full gap-1 border-[1px] rounded-[0.5rem] p-3 border-[#141c48] hover:text-white text-[#3b76db] hover:bg-[#004C97] font-semibold">
          <button className="text-xl">{btnText}</button>
          <FaArrowRight className=" text-[#004C97]  hover:text-white my-auto text-2xl" />
        </div>
      </div>
    </div>
  );
};

export default Starter;
